export const didRequestsPath = "/dids/requests"
export const logisticsPath = "/dids/logistics"
export const allDidRequestsPath = "/dids/logistics/requests"
export const didInvestigationsPath = "/dids/logistics/investigations"
export const emailDetailPath = "/dids/logistics/investigations/:emailMessageId/resolve"
